export const readJWTData = <T>(jwt: string): T => {
  const base64Data = jwt.split('.')[1]
  if (!base64Data) {
    return {} as T
  }
  const buffer = atob(base64Data)
  return JSON.parse(buffer.toString())
}

export const bearerToken = (jwt: string) => `Bearer ${jwt}`
